<template>
    <b-modal
        v-model="modalDetailsLicense.isOpen"
        title="Detalles de la licencia"
        hide-footer
        id="modal-details-license"
        :size="sizeModal"
    >

        <!-- detalles del contrato -->
        <b-row v-if="!getIsVisibleDetailsLicensingContract">
            <b-col cols="12">

                <b-form-group>
                    <b-row>
                        <b-col><b>Fecha de inicio:</b> <input class="form-control" v-model="dateStart" disabled /></b-col>
                        <b-col><b>Fecha de fin:</b> <input class="form-control" v-model="dateEnd" disabled /></b-col>
                    </b-row>
                </b-form-group>

                <div class="card card-body">
                    <b-row>
                        <b-col sm="6" md="6"><b>Cantidad usuarios</b></b-col>
                        <b-col sm="6" md="6">
                            <p class="badge badge-primary">{{ licencia.cantidad_usuarios }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6" md="6"><b>Multiusuarios</b></b-col>
                        <b-col sm="6" md="6">
                            <p :class="licencia.usuarios_multiusuarios ? 'badge badge-primary' : 'badge badge-secondary'">{{ licencia.usuarios_multiusuarios ? 'Si' : 'No' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6" md="6"><b>Usuarios contratistas</b></b-col>
                        <b-col sm="6" md="6">
                            <p :class="licencia.usuarios_multiusuarios ? 'badge badge-primary' : 'badge badge-secondary'">{{ licencia.usuarios_contratistas ? 'Si' : 'No'}}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6" md="6"><b>Modalidad de pago</b></b-col>
                        <b-col sm="6" md="6">
                            <p>{{ paymentMethodCurrentActived }}</p>
                        </b-col>
                    </b-row>
                    <b-row v-if="!!licencia.modalidad_pago">
                        <b-col sm="6" md="6"><b>Precio</b></b-col>
                        <b-col sm="6" md="6">
                            <p><b>{{ getPriceFormated }}</b></p>
                        </b-col>
                    </b-row>
                    <b-row v-if="licencia.modalidad_pago == 198">
                        <b-col sm="6" md="6"><b>Horas</b></b-col>
                        <b-col sm="6" md="6">
                            <p>{{ licencia.horas }}</p>
                        </b-col>
                    </b-row>
                    <b-row >
                        <b-col sm="6" md="6"><b>Responsable</b></b-col>
                        <b-col sm="6" md="6">
                            <p><i>{{ responsible.name }}</i></p>
                        </b-col>
                    </b-row>
                </div>

            </b-col>

            <div class="mx-3 card card-body">
                <b-row>
                    <b-col sm="12" md="12"><b>Observaciones</b></b-col>
                    <b-col sm="12" md="12">
                        <p>{{ licencia.observaciones }}</p>
                    </b-col>
                </b-row>
            </div>

        </b-row>

        <!-- leer el texto del contrato -->
        <div class="card card-body">
            <div>
                <a href="#" @click="changeStatusSeeDetails()" class="font-weight-bold">
                    <i class="fa mr-2" :class="{
                        'fa-arrow-up': getIsVisibleDetailsLicensingContract,
                        'fa-arrow-down': !getIsVisibleDetailsLicensingContract
                    }"></i>
                    {{ !getIsVisibleDetailsLicensingContract ? 'Leer' : 'Ocultar'}}
                    contrato de licenciamiento de Soluquim.
                </a>
                <br />
                <div v-if="getIsVisibleDetailsLicensingContract" class="mt-4" v-html="licencia.licensing_contract"></div>
            </div>
        </div>

        <!--  botones footer -->
        <b-row class="mt-4">
            <hr />
            <div class="display-flex jsutify-content-center flex-row">
                <b-button variant="secondary" @click="cancelProcess">
                    <i class="fa fa-close" />
                    Cancelar
                </b-button>
                <b-button class="mr-3 ml-2" variant="primary" @click="licenceAcepted">
                    <i class="fa fa-save mr-1" />
                    Aceptar contrato de licencia
                </b-button>
            </div>
        </b-row>

    </b-modal>
</template>

<script>

import { mapMutations, mapState, mapActions } from 'vuex';

export default {
    name: 'ModalDetailsAndConfirmation',
    data() {
        return {
            sizeModal: 'lg'
        }
    },
    computed: {
        ...mapState('licencias', [
            'licencia',
            'modalDetailsLicense',
            'optionsMultiUser',
            'paymentMethods',
            'isVisibleDetailsLicensingContract'
        ]),
        showField() {
            const id_modalidad = this.licencia.modalidad_pago;
            return !!this.paymentMethods.find(m => m.id === id_modalidad && m.codigo === 'fdp002');
        },
        responsible() {
            const dataResponsable = this.licencia.responsible;
            if (dataResponsable === null || dataResponsable === '' || dataResponsable === undefined) return { id: '', name: '' }

            return 'name' in dataResponsable ? dataResponsable : { id: '', name: '' }
        },
        dateStart() {
            return this.licencia.fechas[0];
        },
        dateEnd() {
            return this.licencia.fechas[1];
        },
        paymentMethodCurrentActived() {
            let searchPayment = this.paymentMethods.find(x => x.id == this.licencia.modalidad_pago);
            return (searchPayment) ? searchPayment.lista : "Ninguna";
        },
        getPriceFormated() {
            let options = {
                style: 'currency',
                currency: 'COP',
                minimumFractionDigits: 2,
            }

            return new Intl.NumberFormat('en-ES', options).format(this.licencia.precio);
        },
        getIsVisibleDetailsLicensingContract() {
            return this.isVisibleDetailsLicensingContract == 'close' ? false : true
        }
    },
    methods: {
        ...mapMutations('licencias', [
            'setModalDetailsLicence',
            'setIsVisibleDetailsLicensingContract'
        ]),
        ...mapActions('licencias', [
            'licenseApproved',
        ]),
        // cancelar proceso
        cancelProcess() {
            this.setModalDetailsLicence(false);
        },
        // aceptar licencia
        async licenceAcepted() {
            await this.licenseApproved({
                companyId: this.licencia.id_empresa,
                id: this.licencia.id
            });
        },
        changeStatusSeeDetails() {
            this.setIsVisibleDetailsLicensingContract(this.isVisibleDetailsLicensingContract == 'close' ? 'open' : 'close');
            if (this.isVisibleDetailsLicensingContract == 'open') this.sizeModal = 'xl';
            else this.sizeModal = 'lg';
        }
    }
};
</script>

<style scoped>
*:disabled{
    font-weight: bold !important;
    background: white !important;
}
p{
    margin-bottom: 5px;
}
</style>
